import { render, staticRenderFns } from "./RubricatorValueList.vue?vue&type=template&id=32d8570a&scoped=true"
import script from "./RubricatorValueList.vue?vue&type=script&lang=js"
export * from "./RubricatorValueList.vue?vue&type=script&lang=js"
import style0 from "./RubricatorValueList.vue?vue&type=style&index=0&id=32d8570a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d8570a",
  null
  
)

export default component.exports